import { useMemo } from 'react'
import { GetFormat, useGet } from 'sharedKernel/api'

export const useGetProgramFiles = (challengeId?: string) => {
  const request = useMemo<GetFormat>(() => ({
    url: `/v1/hub/company/challenge/${challengeId}/files`
  }), [challengeId])

  const query = useGet(
    request,
    `challenge-files-${challengeId}`,
    { enabled: !!challengeId }
  )

  return query
}